import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

import { ReactComponent as LeftArrow } from "assets/left-arrow.svg";

import { AuthContext } from "../../../contexts/auth.context";

import useTranslate from "../../../hooks/use-translate";

import "../../login/login.style.scss";

const Verification = () => {
	const { resetPassword } = useContext(AuthContext);
	const t = useTranslate("Verification");
	const navigate = useNavigate();

	const handleSubmit = async (event) => {
		// event.preventDefault();
		// const email = event.target.email.value;
		// await resetPassword(email);
		navigate("/");
	};

	return (
		<div className="login-container">
			<div className="login-left-side">
				{"// PLACEHOLDER //"}
				<br />
				{"// ADVERTISEMENT //"}
				<br />
				{"// IMAGE //"}
				<br />
				{"// LOGO //"}
				<br />
				{"// INTRO //"}
			</div>
			<form className="login-right-side" onSubmit={handleSubmit}>
				<div className="login-form-container">
					<Link to={"/"} style={{ width: "min-content" }}>
						<LeftArrow style={{ fontSize: "2rem" }} />
					</Link>
					<span className="title margin-m--top">{t("new password").toUpperCase()}</span>
					<input
						className="text-box"
						type="text"
						placeholder={t("New Password")}
						name="password1"
					/>
					<input
						className="text-box"
						type="text"
						placeholder={t("New Password Again")}
						name="password2"
					/>
					<div className="flex flex--start-items">
						{/* {error && <WarningBox text={ERROR_CODES[error]} />} */}
						<button
							className="btn btn--red size500 w500 padding-s--block padding-xxl--inline margin-auto--left"
							type="submit"
						>
							{t("confirm").toUpperCase()}
						</button>
					</div>
				</div>
			</form>
		</div>
	);
};

export default Verification;
